import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import HeaderIconUser from '../IconUser';

// 已经登录
export default function HeaderUserLogin() {
    const { locale = 'us' } = useRouter();
    return (
        <EcoLink
            href={`/${locale}/my-overview`}
            className="HeaderV2-r-item HeaderV2-r-item-UserLogin GtmModuleData-btn-common"
            aria-label={'user'}
            data-btn-id="user"
            dataLayer={{
                event: 'uaEvent',
                event_name: 'top_function',
                button_name: 'Brand_My Account_Logged in',
                __btn_id1: `ef-header-user`,
                __btn_id2: `user`,
                __btn_type: 'common',
            }}
        >
            <HeaderIconUser />
        </EcoLink>
    );
}
